<div class="instructions--container">
    <h1>Attack Steps</h1>
    <div class="instructions-content--container">
        <div>
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Username Enumeration</mat-card-title>
                    <mat-card-subtitle>Step One</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div>
                        <div>Peak Insurance's web user registration form is vulnerable! You were able to scrape LinkedIn for 1,000 insurance agencies who do business with Peak Insurance.</div>
                        <br>
                        <div>Can you enumerate a valid user account?</div>
                    </div>
                </mat-card-content>
                <mat-card-footer>
                    <mat-card-actions>
                        <a href="/files/EMAIL_LIST.txt" download><button mat-button mat-stroked-button class="white-button">Download Email List</button></a>
                        <a href="/register"><button mat-button mat-raised-button class="blue-button">Begin Step One</button></a>
                    </mat-card-actions>
                </mat-card-footer>
            </mat-card>
        </div> 
        <div>
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Password Brute Force</mat-card-title>
                    <mat-card-subtitle>Step Two</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div>
                        <div>Peak Insurance's password database was recently compromised! For a couple bitcoin you were able to purchase the 100,000 password list on a dark web forum.</div>
                        <br>
                        <div>Can you access the secured site?</div>
                    </div>
                </mat-card-content>
                <mat-card-footer>
                    <mat-card-actions>
                        <a href="/files/PASSWORD_LIST.txt" download><button mat-button mat-stroked-button class="white-button">Download Password List</button></a>
                        <a href="/login"><button mat-button mat-raised-button class="blue-button">Begin Step Two</button></a>
                    </mat-card-actions>
                </mat-card-footer>
            </mat-card>
        </div>
    </div>
</div>